import { render, staticRenderFns } from "./TrainStopOver.vue?vue&type=template&id=2f5fa62b&scoped=true&"
import script from "./TrainStopOver.vue?vue&type=script&lang=js&"
export * from "./TrainStopOver.vue?vue&type=script&lang=js&"
import style0 from "./TrainStopOver.vue?vue&type=style&index=0&id=2f5fa62b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5fa62b",
  null
  
)

export default component.exports